exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".root---2k7yS{width:100vw;height:100vh;display:flex;flex-direction:column;font-family:Helvetica,sans-serif}", ""]);

// Exports
exports.locals = {
	"root": "root---2k7yS"
};